import * as Types from '../types-api.generated';

import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { apiFetcher } from 'lib/clients/graphql';

import { ClientError } from "graphql-request";
import { Address } from "viem";
import { ChainId } from "lib/chains";

export type ApiHasWorldsVariables = Types.Exact<{
  publicKey: Types.Scalars['String'];
}>;


export type ApiHasWorlds = { worlds: Array<{ id: number }> };



export const ApiHasWorldsDocument = /*#__PURE__*/ `
    query HasWorlds($publicKey: String!) {
  worlds: exhibitionByCurator(accountAddress: $publicKey) {
    id
  }
}
    `;

export const useHasWorlds = <
      TData = ApiHasWorlds,
      TError = ClientError
    >(
      variables: ApiHasWorldsVariables,
      options?: Omit<UseQueryOptions<ApiHasWorlds, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApiHasWorlds, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApiHasWorlds, TError, TData>(
      {
    queryKey: ['HasWorlds', variables],
    queryFn: apiFetcher<ApiHasWorlds, ApiHasWorldsVariables>(ApiHasWorldsDocument, variables),
    ...options
  }
    )};

useHasWorlds.getKey = (variables: ApiHasWorldsVariables) => ['HasWorlds', variables];

export const useInfiniteHasWorlds = <
      TData = InfiniteData<ApiHasWorlds>,
      TError = ClientError
    >(
      variables: ApiHasWorldsVariables,
      options: Omit<UseInfiniteQueryOptions<ApiHasWorlds, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApiHasWorlds, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApiHasWorlds, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['HasWorlds.infinite', variables],
      queryFn: (metaData) => apiFetcher<ApiHasWorlds, ApiHasWorldsVariables>(ApiHasWorldsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteHasWorlds.getKey = (variables: ApiHasWorldsVariables) => ['HasWorlds.infinite', variables];


useHasWorlds.fetcher = (variables: ApiHasWorldsVariables, options?: RequestInit['headers']) => apiFetcher<ApiHasWorlds, ApiHasWorldsVariables>(ApiHasWorldsDocument, variables, options);
